/**
 * Create child settings map from merge analysis configuration
 * Supports both array-based and object-based configurations
 */
export function createChildSettingsMap(config: any): Map<string, { tp_usd: number; sl_usd: number; quantity: number }> {
  const settingsMap = new Map<string, { tp_usd: number; sl_usd: number; quantity: number }>();
  
  if (!config) {
    console.log('createChildSettingsMap: No config provided');
    return settingsMap;
  }

  // Handle array-based configuration (legacy format)
  if (Array.isArray(config)) {
    console.log('createChildSettingsMap: Processing array-based config with', config.length, 'items');
    config.forEach((child: any) => {
      if (child.child_bot_id && child.tp_usd !== undefined && child.sl_usd !== undefined && child.quantity !== undefined) {
        settingsMap.set(child.child_bot_id, {
          tp_usd: Number(child.tp_usd),
          sl_usd: Number(child.sl_usd),
          quantity: Number(child.quantity)
        });
      }
    });
    return settingsMap;
  }

  // Handle object-based configuration with children property
  if (config.children && Array.isArray(config.children)) {
    console.log('createChildSettingsMap: Processing config.children with', config.children.length, 'items');
    config.children.forEach((child: any) => {
      if (child.child_bot_id && child.tp_usd !== undefined && child.sl_usd !== undefined && child.quantity !== undefined) {
        settingsMap.set(child.child_bot_id, {
          tp_usd: Number(child.tp_usd),
          sl_usd: Number(child.sl_usd),
          quantity: Number(child.quantity)
        });
      }
    });
    return settingsMap;
  }

  // Handle flat object-based configuration (newer format)
  // Keys are bot IDs, values contain tp_usd, sl_usd, quantity, instrument
  if (typeof config === 'object') {
    console.log('createChildSettingsMap: Processing flat object config with keys:', Object.keys(config));
    Object.entries(config).forEach(([key, value]: [string, any]) => {
      // Check if key looks like a UUID (child_bot_id) and value has required properties
      if (typeof value === 'object' && value !== null && 
          value.tp_usd !== undefined && value.sl_usd !== undefined && value.quantity !== undefined) {
        settingsMap.set(key, {
          tp_usd: Number(value.tp_usd),
          sl_usd: Number(value.sl_usd),
          quantity: Number(value.quantity)
        });
        console.log(`createChildSettingsMap: Added settings for ${key}:`, {
          tp_usd: Number(value.tp_usd),
          sl_usd: Number(value.sl_usd),
          quantity: Number(value.quantity)
        });
      }
    });
  }

  console.log('createChildSettingsMap: Final settings map size:', settingsMap.size);
  return settingsMap;
}